/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: contacts-service.ts
 *
 * Created by randysorensen on 10/2/17.
 */

'use strict';

angular
    .module('prism-ui.system')
    .service('ContactsService', function (
        this: JS5Object,
        _: JS5Object,
        $location: JS5Object,
        $q: JS5Object,
        $route: JS5Object,
        $routeParams: JS5Object,
        ContactsResourceFactory: JS5Object,
        NotificationService: JS5Object,
        PaginationService: JS5Object) {

        this.getContactsList = (queryOpts: JS5Object) => {
            return ContactsResourceFactory.query(queryOpts, (contacts: JS5Object[], headersCB: JS5Function) => {
                PaginationService.parseResponseHeaders(headersCB());
            }).$promise;
        };

        this.createContact = (contact: JS5Object) => {
            return ContactsResourceFactory.save(contact).$promise;
        };

        this.getContact = (contactId: number) => {
            return ContactsResourceFactory.get({
                contactId: contactId
            }).$promise;
        };

        this.updateContact = (contact: JS5Object) => {
            return ContactsResourceFactory.update(contact).$promise;
        };

        this.toggleContactVisibility = (contactId: number) => {
            return ContactsResourceFactory.delete({
                contactId: contactId
            }).$promise;
        };

        this.getContactEditData = () => {
            let contactPromise: JS5Promise;
            let contactId = $routeParams.contactId;

            if (contactId < 0) {
                let contactDeferral = $q.defer();
                contactDeferral.resolve({
                    // In Flex this defaults to false for new
                    // contacts.
                    enabled: false
                });
                contactPromise = contactDeferral.promise;
            } else {
                contactPromise = this.getContact(contactId);
            }

            return contactPromise.then((contact: JS5Object) => {
                this.contact = contact;
                this.originalContact = _.cloneDeep(contact);

                return contact;
            });
        };

        this.canExitEditView = () => {
            const contactIsSaved = !!_.get(this.contact, 'id');
            return !this.editorForm || (contactIsSaved && this.editorForm.$pristine);
        };

        const closeEditView = () => {
            this.contact = undefined;
            this.originalContact = undefined;
            this.editorForm = undefined;

            $location.path($route.current.rootRoute);
        };

        this.showUnsavedChangesNotification = () => {
            NotificationService.createWarningNotification('You have unsaved changes. Please save or revert.');
        };

        this.exitEdit = () => {
            if (this.canExitEditView()) {
                closeEditView();
            } else {
                this.showUnsavedChangesNotification();
            }
        };

        this.revertEditData = () => {
            this.contact = _.cloneDeep(this.originalContact);
            this.editorForm.$setPristine();
            return this.contact;
        };

        this.saveEditData = () => {
            let saveFunction: JS5Function;

            if ($routeParams.contactId < 0) {
                saveFunction = this.createContact;
            } else {
                saveFunction = this.updateContact;
            }

            return saveFunction(this.contact)
                .then((savedContact: JS5Object) => {
                    this.contact = savedContact;
                    this.originalContact = _.cloneDeep(savedContact);

                    $route.updateParams({
                        contactId: savedContact.id
                    });

                    this.editorForm.$setPristine();
                    return this.contact;
                }).catch((error: JS5Object) => {
                    NotificationService.createFailureNotification(
                        'An error occurred while saving the contact.',
                        error.data.message);
                });
        };

    });
